export default __webpack_public_path__ + "static/media/blue-logo.fb3225d8.svg";